import {
	FeatureType,
	RoomDynamic,
	RoomDynamicDataDto
} from '@wwt/entities/api/search-response'

import { addTypeToFeatures } from './utils/addTypeToFeatures.ts'

export const getRoomDynamic = (
	roomDynamicBase: RoomDynamicDataDto
): RoomDynamic => {
	const roomDynamic: RoomDynamic = {
		// TODO: Remove structuredClone
		// eslint-disable-next-line
		...structuredClone(roomDynamicBase),
		includedFeatures: addTypeToFeatures(
			roomDynamicBase.includedFeatures ?? [],
			FeatureType.included
		),
		bookableNotPackagedFeatures: addTypeToFeatures(
			roomDynamicBase.bookableNotPackagedFeatures ?? [],
			FeatureType.bookableNotPackaged
		),
		bookablePackagedFeatures: addTypeToFeatures(
			roomDynamicBase.bookablePackagedFeatures,
			FeatureType.bookablePackaged
		),
		checkInFeatures: addTypeToFeatures(
			roomDynamicBase.checkInFeatures ?? [],
			FeatureType.checkIn
		)
	}

	if (
		!('includedFeatures' in roomDynamicBase) &&
		(roomDynamic.includedFeatures === undefined ||
			roomDynamic.includedFeatures.length === 0)
	) {
		delete roomDynamic.includedFeatures
	}

	if (
		!('checkInFeatures' in roomDynamicBase) &&
		(roomDynamic.checkInFeatures === undefined ||
			roomDynamic.checkInFeatures.length === 0)
	) {
		delete roomDynamic.checkInFeatures
	}

	if (
		!('bookableNotPackagedFeatures' in roomDynamicBase) &&
		(roomDynamic.bookableNotPackagedFeatures === undefined ||
			roomDynamic.bookableNotPackagedFeatures.length === 0)
	) {
		delete roomDynamic.bookableNotPackagedFeatures
	}

	return roomDynamic
}
